'use client';

import { createClient } from '@/lib/supabase/client';

interface VolunteerSignupData {
  opportunityId: number;
  opportunityTitle: string;
  location: string;
  volunteerName: string;
  volunteerEmail: string;
  volunteerPhone?: string;
  skills?: string[];
  availability?: string;
  motivation?: string;
}

function isSchemaError(error: any): boolean {
  if (!error) return false;
  
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
    if (errorClass === '23') {
      return false;
    }
  }
  
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
    ];
    return schemaErrorPatterns.some(pattern => pattern.test(error.message));
  }
  
  return false;
}

export const volunteerService = {
  async signUp(data: VolunteerSignupData) {
    const supabase = createClient();

    try {
      const { data: result, error } = await supabase
        .from('volunteer_applications')
        .insert({
          full_name: data.volunteerName,
          email: data.volunteerEmail,
          phone: data.volunteerPhone || null,
          opportunity_id: data.opportunityId,
          opportunity_title: data.opportunityTitle,
          location: data.location,
          skills: data.skills || [],
          motivation: data.motivation || null,
          availability: data.availability || null,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return null;
        }
      }

      return result;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};